webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(20)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(47),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(22)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(49),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(18)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(45),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(17)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(44),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(48),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(19)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 11 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 12 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vuetify from 'vuetify'

/***/ }),
/* 13 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 14 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 15 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(8);
// Initialization ______________________________________________________________


// import VueParallaxJs from 'vue-parallax-js'
// import Vuetify from 'vuetify'

__webpack_require__(1);
// import 'vuetify/dist/vuetify.min.css';

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
// Vue.use(VueParallaxJs)
// Vue.use(Vuetify)

// Routes ______________________________________________________________________
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{ path: '/welcome', component: __webpack_require__(4), meta: { title: 'Welcome' } }, { path: '/retrospective', component: __webpack_require__(5), meta: { title: 'Retrospective' } }, { path: '/timeline', component: __webpack_require__(7), meta: { title: 'Timeline' } }, { path: '/calendar', component: __webpack_require__(2), meta: { title: 'Travelling Exhibition' } }, { path: '/contact', component: __webpack_require__(3), meta: { title: 'Contact' } }, { path: '/thanks', component: __webpack_require__(6), meta: { title: 'Thanks' } },
// { path: "*", component: require('./pages/404.vue'), meta: {title: 'Oops'}}
{ path: '*', redirect: './welcome' }];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	routes: routes,
	// mode: 'history',
	base: '/Lumiere/',
	scrollBehavior: function scrollBehavior(to, from, savedPosition) {
		return { x: 0, y: 0 };
	}
});

router.beforeEach(function (to, from, next) {
	document.title = to.meta.title;
	next();
});

// Directives __________________________________________________________________
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('skroll', {
	bind: function bind(el, binding) {
		el.$onScroll = function () {
			var rect = el.getBoundingClientRect();
			var d = Math.max(0, 50 - rect.top) / 100;

			var bright = Math.max(100, Math.min(120, Math.floor(20 * d)));
			var blur = Math.max(0, Math.min(5, Math.floor(5 * d)));
			var gray = Math.max(0, Math.min(100, Math.floor(20 * d)));

			el.style = 'filter: brightness(' + bright + '%) blur(' + blur + 'px) grayscale(' + gray + '%)';
		};
		document.addEventListener('scroll', el.$onScroll);
	},
	inserted: function inserted(el, binding) {
		el.$onScroll();
	},
	unbind: function unbind(el, binding) {
		document.removeEventListener('scroll', el.$onScroll);
		delete el.$onScroll;
	}
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('skromm', {
	bind: function bind(el, binding) {
		el.$onScroll = function () {
			var rect = el.getBoundingClientRect();
			var d = Math.max(0, 100 - rect.top) / 100;

			var opacity = Math.max(.2, Math.min(1, 1 - d));
			var blur = Math.max(0, Math.min(5, Math.floor(5 * d)));

			el.style = 'filter: blur(' + blur + 'px); opacity: ' + opacity;
		};
		document.addEventListener('scroll', el.$onScroll);
	},
	inserted: function inserted(el, binding) {
		el.$onScroll();
	},
	unbind: function unbind(el, binding) {
		document.removeEventListener('scroll', el.$onScroll);
		delete el.$onScroll;
	}
});

// Mounting App ________________________________________________________________
var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	router: router
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bord_de_mer.06ccaa5.jpg";

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/brochure_lumiere.1a3f346.jpg";

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/brochure_lumiere2.d913a1c.jpg";

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/carte_mexique.284df5e.jpg";

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/catalogue_general.97f8c6a.jpg";

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ecriture.50b6520.jpg";

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/grand_prix.3d20dcb.jpg";

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/instantane.b5d2fc6.jpg";

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/notice_cinematographe.450aab6.jpg";

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/planche.3716094.jpg";

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/plaques_autochromes.499ada0.jpg";

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/portrait.180a6ca.jpg";

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/projecteur.8ffbd1d.jpg";

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/salon.977f952.jpg";

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/salon_du_cinematographe.e15acd7.jpg";

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/stereosynthese_henri_lumiere.8323c4c.jpg";

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/vieux.224cfc3.jpg";

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aroseur.bcf7de8.mp4";

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bebe.295fa78.mp4";

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sortie_usine.31e5887.mp4";

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/video.314d04d.mp4";

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "xxl"
  }, [_c('video', {
    directives: [{
      name: "skroll",
      rawName: "v-skroll"
    }],
    attrs: {
      "src": __webpack_require__(43),
      "autoplay": "",
      "loop": "",
      "muted": "",
      "poster": "http://mc3.co/Lumiere/static/media/video.jpg"
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "cols2"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "xxl"
  }, [_c('img', {
    directives: [{
      name: "skroll",
      rawName: "v-skroll"
    }],
    attrs: {
      "src": __webpack_require__(31)
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "xxl"
  }, [_c('img', {
    directives: [{
      name: "skroll",
      rawName: "v-skroll"
    }],
    attrs: {
      "src": __webpack_require__(38)
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "xxl"
  }, [_c('img', {
    directives: [{
      name: "skroll",
      rawName: "v-skroll"
    }],
    attrs: {
      "src": __webpack_require__(30)
    }
  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "xxl"
  }, [_c('video', {
    directives: [{
      name: "skroll",
      rawName: "v-skroll"
    }],
    attrs: {
      "src": __webpack_require__(40),
      "autoplay": "",
      "loop": "",
      "poster": "http://mc3.co/Lumiere/static/media/aroseur.jpg"
    }
  })]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "xxl"
  }, [_c('img', {
    directives: [{
      name: "skroll",
      rawName: "v-skroll"
    }],
    attrs: {
      "src": __webpack_require__(33)
    }
  })]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "xxl"
  }, [_c('video', {
    directives: [{
      name: "skroll",
      rawName: "v-skroll"
    }],
    attrs: {
      "src": __webpack_require__(41),
      "autoplay": "",
      "loop": "",
      "poster": "http://mc3.co/Lumiere/static/media/bebe.jpg"
    }
  })]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "xxl"
  }, [_c('img', {
    directives: [{
      name: "skroll",
      rawName: "v-skroll"
    }],
    attrs: {
      "src": __webpack_require__(24)
    }
  })]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "xxl"
  }, [_c('img', {
    directives: [{
      name: "skroll",
      rawName: "v-skroll"
    }],
    attrs: {
      "src": __webpack_require__(35)
    }
  })]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "xxl"
  }, [_c('img', {
    directives: [{
      name: "skroll",
      rawName: "v-skroll"
    }],
    attrs: {
      "src": __webpack_require__(26)
    }
  })]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "xxl"
  }, [_c('img', {
    directives: [{
      name: "skroll",
      rawName: "v-skroll"
    }],
    attrs: {
      "src": __webpack_require__(37)
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('h1', [_vm._v("Transforming images")]), _vm._v(" "), _c('p', [_vm._v("The exhibition examines the lasting links between early cinema and modern day cinema: how does our enlightened spectator’s eye, subjected daily to a multitude of images in motion, ‘receive’ and interpret these pioneering images? The exhibition offers the opportunity to compare fixed or animated images from the past with those of the digital era, to think about issues relating to images, the technique and the way they have been 'received' throughout cinema’s history.")]), _vm._v(" "), _c('p', [_vm._v("From the Lumière film boxes manufactured in the family factories to tactile digital screens, the scenographic displays illustrate these evolutions in an intrinsic manner. The didactic and educational exhibition gives pride of place to the importance of the cinema image that at the beginning of the twenty-first century is sometimes relegated to the miniature space of a mobile telephone screen. Appealing to the spectator’s sensitivity and emotions, the journey and the scenographic installation contribute to ‘re-enchanting’ the images and re-confer their original magic upon them.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('h1', [_vm._v("From pre-cinema to the first collective screening")]), _vm._v(" "), _c('p', [_vm._v("Thanks to the persistence of vision phenomenon discovered in the early sixteenth century, the enthusiasm for optical toys led to the emergence of numerous image animation systems. During the nine teenth century, numerous scientists invented devices such as the Thaumatrope or the Zootrope to recreate the illusion of movement using drawings, etchings and later photographs.")]), _vm._v(" "), _c('p', [_vm._v("Starting from these early stages, the inventors Marey, Muybridge and Edison developed motion capture devices and then tools that regulated the speed at which the images scrolled past. Inspired by these technical inventions that arrived on the scene at the end of the nineteenth century, the Lumière brothers developed the Cinematograph, literally ‘the motion writer’, a device capable of shooting, making copies and projecting them.")]), _vm._v(" "), _c('p', [_vm._v("This device marks a major turning point in the evolution of filming technologies. The Lumière brothers lead the way forward to twentieth century cinema and the world of cinematography becomes fertile ground for research and experimentation. Above and beyond the initial technical feat, the Lumière brothers also introduce the collective experience of the sharing of images by organizing the first public fee-paying screening at the Salon Indien of the Grand Café in Paris on 28 December 1895. The ten films projected during the first session are screened in the exhibition in 35mm restored copies inside a specially built replica of the Salon Indien imagined by the interior decorator Jacques Grange. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('h1', [_vm._v("The Lumière films: filming reality beyond borders")]), _vm._v(" "), _c('p', [_vm._v("The 1.400 Lumière films made between 1895 and 1905, all projected in full in the exhibition illustrate the extensive volume of Lumière films produced at the beginning of the twentieth century and the diversity of the subjects filmed: scenes from daily life, landscapes, official events, the early days of comedy, etc. For today’s spectator, the films are an important cinematographic heritage, with each image reflecting a vision of society at the beginning of the twentieth century.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("Driven by the desire to share animated photographic images with as many people as possible, the Lumière brothers trained a hundred or so operators on filming and projection techniques. Sent to the four corners of the globe with the camera under their arm, they captured unprecedented images from faraway territories. The films show the extraordinary diversity of the subjects captured on film and comprise the first animated archives from the eve of the twentieth century. These films also bear witness to the excellent quality of their shooting and the modernity of their writing. They illustrate the importance granted to cinematographic techniques. Louis Lumière and his operators developed the first cinematographic language, one that marks the history of the art and is echoed by filmmakers throughout the twentieth century.")]), _vm._v(" "), _c('p', [_vm._v("They lay the foundations for the production, exploitation and distribution of cinematographic images, all disciplines that today forge the identity of the cinema industry.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('h1', [_vm._v("The Lumière heritage in the twentieth and twenty-first century:\naesthetic permanence and technological change")]), _vm._v(" "), _c('p', [_vm._v("The Lumière trace in cinema exists, like a heritage laid claim to by the directors who followed in their footsteps and in whose films we find either an idea for a shot, a common inspirational theme, a way of centering or a subject. Right from the start, Lumière and the operators asked themselves film-makers’ questions – the very same questions that thousands of artists after them have asked and continue to ask in their own way. It is more a question of a way of making cinema: recording reality, depicting life in motion in its most obvious, vivid and eternal demise. Here, extracts from the works of twentieth and twenty-first century filmmakers are confronted with the Lumière’s cinema. A confrontation of pioneering images with those of yesterday and today that enables us to capture the permanence of the \"Lumière trace\" and see the extent to which the Lumière aesthetics are already that of modernity.")]), _vm._v(" "), _c('p', [_vm._v("Lumière is to be found in the work of the French directors "), _c('i', [_vm._v("Jean Renoir")]), _vm._v(", "), _c('i', [_vm._v("Robert Bresson")]), _vm._v(" and "), _c('i', [_vm._v("Maurice Pialat")]), _vm._v(", in that of the neo-realist Italians in the fifties and in the work of "), _c('i', [_vm._v("Roberto Rossellini")]), _vm._v(" throughout his career, and in the work of "), _c('i', [_vm._v("Bertrand Tavernier")]), _vm._v(" when he draws inspiration from the color of the Autochromes to shoot Un Dimanche à la campagne, not forgetting "), _c('i', [_vm._v("Abbas Kiarostami")]), _vm._v(", the figurehead of Iranian cinema who knows how to rediscover the innocence of the very first gestures.")]), _vm._v(" "), _c('p', [_vm._v("If, from an artistic perspective, the permanence of the Lumière heritage remains, what about the technical aspects? 125 years after the advent of film that imprinted light on its sensitized surface, have the processes for capturing the real world evolved? During the twentieth century, cinema has undergone many technical and artistic changes. The switch from conventional to digital has definitively transformed filming and projection systems. Film has disappeared and been replaced by digital. Whether it is seen as a transformation or a transfer, the digital era has brought about a change in the nature of the image captured and projected. This transfer affects cinema in its very essence, from the redefinition of the professional environments to the elaboration of new aesthetic theories.")]), _vm._v(" "), _c('p', [_vm._v("Filmmakers such as "), _c('i', [_vm._v("Jerry Schatzberg")]), _vm._v(", "), _c('i', [_vm._v("Xavier Dolan")]), _vm._v(", "), _c('i', [_vm._v("Michael Cimino")]), _vm._v(", "), _c('i', [_vm._v("Pedro Almodóvar")]), _vm._v(", "), _c('i', [_vm._v("Paolo Sorrentino")]), _vm._v(" and "), _c('i', [_vm._v("Quentin Tarantino")]), _vm._v(" have been invited to revisit the first film, Sortie d’usine, by 're-shooting' it in their own way at the original film site, the Hangar du Premier Film in Lyon in 1895.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('h1', [_vm._v("Creating movement:"), _c('br'), _vm._v("The early cinema")]), _vm._v(" "), _c('p', [_vm._v("In the first half of the nineteenth century, a major event marked the history of images: the birth of photography, which conferred upon Art globally the possibility of no longer only ‘representing’ reality as with painting, but of actually capturing it. The history of cinema is born of the ambition to animate and project photos, in other words to breathe movement into fixed images. This determination to capture the reality of the world as closely as possible was the core motivation of Auguste and Louis Lumière who created the Cinematograph, the device that makes it possible to film, make copies and project them.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("Designed based on the Institut Lumière collections that feature many original devices and objects, graphic documents and family archives, the exhibition presents the many facets of the Lumière family and the way in which their sons Louis and Auguste marked their time.")]), _vm._v(" "), _c('p', [_vm._v("A large amount of space is dedicated to the screening of the 1.400 Lumière films in different forms, all marvels with a wide variety of interpretations: mirror images of History, the early days of cinematographic writing, the opening up of the world and also a testimonial to family life at the beginning of the twentieth century.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('h1', [_vm._v("The Lumière industry:"), _c('br'), _vm._v("a family adventure")]), _vm._v(" "), _c('p', [_vm._v("Antoine Lumière and sons. A father and two brothers. A father of modest origin, Antoine Lumière was the son of a midwife and a vineyard worker who left him orphaned at an early age. His two sons, the Lumière brothers, vowed as adolescents to always work together when they were trapped in a dark cave by the rising Brittany tide. Fleeing the Prussian invasion of 1870, the family settled in Lyon.")]), _vm._v(" "), _c('p', [_vm._v("It was in Lyon that the family made its fortune thanks to the manufacture of photographic plates called \"Blue Labels\" invented by Louis Lumière at the age of 17. A few years later, the family enterprise specialized in the production and sale of glass plates, photographic papers and chemical products was highly successful and was number one in Europe. The Lumière factories developed into industrial sites and diversified their production: Lyon was thus the place where photographic films, X-ray films and numerous photochemical products and accessories were manufactured. Objects from this industrial adventure, photos taken by Antoine Lumière and paintings that he did and that bear witness to the time are presented to visitors.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('h1', [_vm._v("The Lumière Contemporaries: Pathé, Gaumont and Méliès")]), _vm._v(" "), _c('p', [_vm._v("Contemporaries of the Lumière brothers, Charles Pathé, Léon Gaumont and Georges Méliès, all influenced the cinematography world and especially its production.")]), _vm._v(" "), _c('p', [_vm._v("“Publishers of cinematographic films”, the two industrialists, Charles Pathé and Léon Gaumont whose activity consisted of producing and distributing films also contributed to making cinema into an industry in France. Méliès, film director, producer and distributor of films gave the cinema industry an aesthetic dimension. A genuine film-maker, he experimented with cinematographic staging. Despite their different cinematographic languages, these four musketeers shared a common vision of cinema.")]), _vm._v(" "), _c('p', [_vm._v("Early cinema paid less attention to the contents of the stories told than to the way the spectators reacted to them. The images fascinated people since they produced an illusion; the illusion of motion with Lumière and of magic with Méliès.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('h1', [_vm._v("Photography, forever...")]), _vm._v(" "), _c('p', [_vm._v("Lumière is not just the Cinematograph: it is an entire lifetime dedicated to images with numerous inventions in the field of photography. The invention of the Cinematograph was part of the photographic work of the Lumière Company since it relies on a device and a sensitized surface as is the case with photography. From this perspective it is an extension of what the family enterprise produced. In 1901, still in the aim of contributing to the modernization of the photographic device, Louis Lumière develops the Photorama, the first panoramic photography process that makes it possible to project a single shot representing a 360° tour of the horizon. In 1903, Louis Lumière patents the first commercial colored photography pro cess that he calls the "), _c('i', [_vm._v("Autochrome")]), _vm._v(". This makes it possible to produce slides on glass plates.")]), _vm._v(" "), _c('p', [_vm._v("In the exhibition, visitors are able to discover original plates that date back to the very beginning of the twentieth century, along with ingenious devices for viewing the plates from around 1910, such as the Chromodiascope. A true pictorial photography process, the Autochrome provokes unequalled aesthetic emotion when the spectator’s eye meets these millions of particles, perceiving the remarkable contrast of the colors and the fineness of the grain in these marvels of photography.")])])
}]}

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "cols2"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "xxl"
  }, [_c('video', {
    directives: [{
      name: "skroll",
      rawName: "v-skroll"
    }],
    attrs: {
      "src": __webpack_require__(42),
      "autoplay": "",
      "loop": "",
      "poster": "http://mc3.co/Lumiere/static/media/sortie_usine.jpg"
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "xxl"
  }, [_c('img', {
    directives: [{
      name: "skroll",
      rawName: "v-skroll"
    }],
    attrs: {
      "src": __webpack_require__(27)
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "xxl"
  }, [_c('img', {
    directives: [{
      name: "skroll",
      rawName: "v-skroll"
    }],
    attrs: {
      "src": __webpack_require__(34)
    }
  })]), _vm._v(" "), _vm._m(3)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("From the Lumière film boxes manufactured in the family factories to tactile digital screens, the scenographic displays illustrate these evolutions in an intrinsic manner. The didactic and educational exhibition gives pride of place to the importance of the cinema image that at the beginning of the twenty-first century is sometimes relegated to the miniature space of a mobile telephone screen. Appealing to the spectator’s sensitivity and emotions, the journey and the scenographic installation contribute to ‘re-enchanting’ the images and re-confer their original magic upon them.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("Inventing Cinema provides visitors with the opportunity to rewind the history of the animated image, from its origins through to the latest production and screening techniques. Over a century separates the first cinematographic experiments from cinema as we know it today. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('h1', [_vm._v("Discover the prodigious beginning of the movie industry through the heritage and the archive of the Lumière Brothers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("The exhibition invites visitors to dive into the rich and creative avant-garde work of the Lumière brothers, examine the aesthetic and technical heritage. How cinema has grown and our relationship to images. It is unique opportunity to compare fixed or animated images from the past with those of the digital era, to think about issues relating to images, the technique and the way they have been 'received' throughout cinema’s history. ")])])
}]}

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cols2",
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "three",
    attrs: {
      "id": "timeline"
    }
  }, [_c('div', {
    directives: [{
      name: "skromm",
      rawName: "v-skromm"
    }],
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\t1870\n\t\t\t\t")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "skromm",
      rawName: "v-skromm"
    }],
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\t1884\n\t\t\t\t")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "skromm",
      rawName: "v-skromm"
    }],
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\t19 March 1895\n\t\t\t\t")]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "skromm",
      rawName: "v-skromm"
    }],
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\t22 March 1895\n\t\t\t\t")]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "skromm",
      rawName: "v-skromm"
    }],
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\tMay 1895\n\t\t\t\t")]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "skromm",
      rawName: "v-skromm"
    }],
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\t28 December 1895\n\t\t\t\t")]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "skromm",
      rawName: "v-skromm"
    }],
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\t1896 and beyond\n\t\t\t\t")]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "skromm",
      rawName: "v-skromm"
    }],
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\t1902\n\t\t\t\t")]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "skromm",
      rawName: "v-skromm"
    }],
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\t1903\n\t\t\t\t")]), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "skromm",
      rawName: "v-skromm"
    }],
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\t1935\n\t\t\t\t")]), _vm._v(" "), _vm._m(9)])]), _vm._v(" "), _vm._m(10)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("The Lumière Family settles in Lyon."), _c('br'), _vm._v("\n\t\t\t\t\tThe Lumière Brothers are 6 and 8 years old.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("The Lumière Company markets the \"Blue Label\" photographic plates, invented by Louis Lumière in 1881."), _c('br'), _vm._v("The Lumière photography factory goes on to become N° 1 in Europe within ten years.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("In Lyon, Louis Lumière shoots the film Sortie d’usine at the Chemin Saint-Victor."), _c('br'), _vm._v("This is the first turning of the Cinematograph hand-crank. In 1929, the Chemin Saint-Victor is re-christened Rue du Premier-Film.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("In Paris, the members of the Société d’Encouragement pour l’Industrie Nationale receive the visit from Louis Lumière who comes to present his Cinematograph."), _c('br'), _vm._v("The screening of "), _c('i', [_vm._v("Sortie d’Usine")]), _vm._v(" is a scientific triumph.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("Louis Lumière shoots new films in Lyon, including "), _c('i', [_vm._v("Le Jardinier")]), _vm._v(" and "), _c('i', [_vm._v("Le Petit Espiègle")]), _vm._v(" that later becomes the famous "), _c('i', [_vm._v("Arroseur et arrosé")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("Return to Paris - Thirty three curious spectators come to the Grand Café on Boulevard des Capucines (today the Hôtel Scribe), right in the middle of the Christmas holidays, to see the first fee-paying public screening of the Cinematograph."), _c('br'), _vm._v("They each pay 1 French franc. During the following weeks, over 2000 Parisians queue up each day to see the projections.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("The Lumière Company and its operators screen and shoot films in the UK, Italy, Spain, Germany, Egypt, Algeria, Tokyo, Moscow, New York, Mexico, etc.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("Louis Lumière opens a Photorama room in Paris able to accommodate several hundreds of spectators for projections of 360° photographs on a giant circular screen.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("Louis Lumière develops the Autochrome, the first commercial process for colored photographs on glass plates, made available to all in 1907.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("Louis Lumière develops his 3D cinematography process: the films are watched using anaglyph glasses.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "two"
  }, [_c('img', {
    staticStyle: {
      "transform": "rotate(3deg)"
    },
    attrs: {
      "src": __webpack_require__(23)
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "transform": "rotate(-2deg)"
    },
    attrs: {
      "src": __webpack_require__(25)
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "transform": "rotate(1deg)"
    },
    attrs: {
      "src": __webpack_require__(29)
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "transform": "rotate(-3deg)"
    },
    attrs: {
      "src": __webpack_require__(36)
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "transform": "rotate(2deg)"
    },
    attrs: {
      "src": __webpack_require__(32)
    }
  })])
}]}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cols2",
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "two"
  }, [_c('img', {
    staticStyle: {
      "transform": "rotate(3deg)"
    },
    attrs: {
      "src": __webpack_require__(28)
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "transform": "rotate(-2deg)"
    },
    attrs: {
      "src": __webpack_require__(39)
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "three",
    attrs: {
      "id": "timeline2"
    }
  }, [_c('div', {
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\tMay 2020 and beyond\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("Traveling exhibition available")])])]), _vm._v(" "), _c('div', {
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\tJune 2019 - March 2020\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("Evian, France")])])]), _vm._v(" "), _c('div', {
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\tJune 2017 - February 2018 \n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("Musee des Confluences - Lyon, France")])])]), _vm._v(" "), _c('div', {
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\tJuly 2016 - March 2017\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("Bologna, Italy")])])]), _vm._v(" "), _c('div', {
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("\n\t\t\t\t\t2015\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "event"
  }, [_c('p', [_vm._v("Grand Palais - Paris, France")])])])])])
}]}

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    attrs: {
      "id": "signup"
    }
  }, [_c('h1', [_vm._v("Thank you")]), _vm._v(" "), _c('p', [_vm._v("We’ll respond as soon as possible.")])])])
}]}

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    attrs: {
      "id": "signup"
    }
  }, [_c('h1', [_vm._v("Question, suggestion?")]), _vm._v(" "), _c('p', [_vm._v("Drop me a line.")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "https://formspree.io/maryse.camelan@gmail.com",
      "method": "POST",
      "id": "mG61Hd2",
      "target": "_self"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "_next",
      "value": "//mc3.co/Lumiere/#/contact"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "Text",
      "placeholder": "Name",
      "required": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "email",
      "name": "Email",
      "jsname": "L9xHkb",
      "placeholder": "Email",
      "required": ""
    }
  }), _vm._v(" "), _c('textarea', {
    attrs: {
      "name": "Message",
      "required": ""
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit",
      "name": "submit",
      "value": "submit"
    }
  }, [_vm._v("Submit")])])])])
}]}

/***/ })
],[16]);


// WEBPACK FOOTER //
// static/js/app.5b9dcf1e61bbffddc493.js